// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BCC1e","selected":"styles_selected__2lZyj"};